export default __webpack_public_path__ + "static/Aury_walk_sequence_IDA_1088x580_v006-e6d327bbf962e4eed2c9079d79c2b348.mp4";